import { AlertOutlined, AppstoreOutlined, BankOutlined, BarChartOutlined, BugOutlined, ContactsOutlined, DatabaseOutlined, FileProtectOutlined, FolderOpenOutlined, HomeOutlined, LaptopOutlined, PlusCircleOutlined, ReadOutlined, RobotOutlined, ScheduleOutlined, SettingOutlined, ShopOutlined, SwapOutlined, ToolOutlined, UserOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import { createElement } from 'react';
import type { Action, Resource } from '@shared/permissions';

export interface NavItem { label: string; to: string; icon: ReactNode; end?: boolean; requires?: { action: Action; resource: Resource } }
export interface NavSection { label: string; items: NavItem[] }

/** Sidebar sections; icons come from Ant Design's outlined set so they match the rest of the UI. */
export const navSections: NavSection[] = [
  { label: 'Favorites', items: [{ label: 'Dashboard', to: '/', icon: createElement(AppstoreOutlined), end: true }, { label: 'Incidents', to: '/incidents', icon: createElement(AlertOutlined) }] },
  {
    label: 'Operations',
    items: [
      { label: 'Ticket Management', to: '/incidents', icon: createElement(AlertOutlined) },
      { label: 'Problem Tracking', to: '/problems', icon: createElement(BugOutlined) },
      { label: 'Change Control', to: '/changes', icon: createElement(SwapOutlined) },
      { label: 'Service Catalog', to: '/catalog', icon: createElement(ShopOutlined) },
    ],
  },
  { label: 'Knowledge & Reports', items: [{ label: 'Knowledge Hub', to: '/knowledge', icon: createElement(ReadOutlined) }, { label: 'Analytics & Reporting', to: '/reports', icon: createElement(BarChartOutlined) }] },
  {
    label: 'AI Agents',
    items: [
      { label: 'Agent Roster', to: '/agents', icon: createElement(RobotOutlined), end: true },
      { label: 'Onboard Agent', to: '/agents/onboard', icon: createElement(PlusCircleOutlined), requires: { action: 'create', resource: 'agent' } },
    ],
  },
  {
    label: 'CRM',
    items: [
      { label: 'CRM Home', to: '/crm', icon: createElement(HomeOutlined), end: true },
      { label: 'Companies', to: '/crm/companies', icon: createElement(BankOutlined) },
      { label: 'Contacts', to: '/crm/contacts', icon: createElement(ContactsOutlined) },
      { label: 'Contracts', to: '/crm/contracts', icon: createElement(FileProtectOutlined) },
      { label: 'Cases', to: '/crm/cases', icon: createElement(FolderOpenOutlined) },
      { label: 'Work Orders', to: '/crm/work-orders', icon: createElement(ToolOutlined) },
      { label: 'Dispatch', to: '/crm/dispatch', icon: createElement(ScheduleOutlined), requires: { action: 'dispatch', resource: 'workOrder' } },
    ],
  },
  { label: 'Asset & Config', items: [{ label: 'CMDB', to: '/cmdb', icon: createElement(DatabaseOutlined) }, { label: 'Asset Registry', to: '/assets', icon: createElement(LaptopOutlined) }] },
  { label: 'System', items: [{ label: 'My Profile', to: '/profile', icon: createElement(UserOutlined) }, { label: 'Portal Administration', to: '/admin', icon: createElement(SettingOutlined), requires: { action: 'read', resource: 'settings' } }] },
];
